import classNames from "classnames";
import { isTerminalBuildState, BuildStates } from "~/constants/BuildStates";
import { CommandJob, TriggerJob } from "~/components/build/Show/lib/types";
import { useStepDependencies } from "~/components/build/Show/lib/useStepDependencies";

interface Props {
  job: CommandJob | TriggerJob;
  build: {
    state: BuildStates;
  };
}

export const MissingDependenciesNode = (props: Props) => {
  const { missingDependencies: missingGroupDependencies } = useStepDependencies(
    props.job.groupUuid,
  );
  const { missingDependencies } = useStepDependencies(props.job.stepUuid);

  if (missingDependencies.length === 0 && missingGroupDependencies.length === 0) {
    return null;
  }

  const isBuildTerminal = isTerminalBuildState(props.build.state);
  const missingDependenciesMessage =
    missingGroupDependencies.length > 0
      ? "Group step dependencies not found"
      : "Step dependencies not found";

  return (
    <div
      className={classNames("job-stats flex-none max-md:sr-only", {
        "rounded bg-orange-500/[0.18] px-1 !text-orange-800": !isBuildTerminal,
      })}
    >
      <span>
        {isBuildTerminal ? missingDependenciesMessage : "Waiting on unresolved dependencies"}
      </span>
    </div>
  );
};
